<template>
  <div>
    <img
      src="../assets/bars-1.svg"
      class="menu-button"
    >
    <img
      src="../assets/img/egresa-do-white.svg"
      class="logo"
      alt
    >
    <h2 class="heading">
      ¿Terminaste tus estudios secundarios?
    </h2>
    <p class="tagline">
      Conoce tus posibilidades y consulta los planes de
      educación disponibles en República Dominicana.
    </p>
    <img
      src="../assets/ellipse-123.svg"
      class="image-ellipse"
    >

    <img
      src="../assets/portrait-of-female-student-standing-in-college-bui-p-6-ktud-5-removebg.png"
      srcset="../assets/portrait-of-female-student-standing-in-college-bui-p-6-ktud-5-removebg@2x.png 2x, ../assets/portrait-of-female-student-standing-in-college-bui-p-6-ktud-5-removebg@3x.png 3x"
      class="image"
    >
  </div>
</template>

<script>
export default {
    name: 'HomeMessage',
};
</script>

<style lang="scss" scoped>
.logo {
  max-width: 180px;
  margin-top: 35px;
  margin-bottom: 30px;
  // margin-bottom: 78px;
}
.heading {
  font-family: "Roboto", sans-serif;
  font-size: 1.875rem;
  font-weight: 900;
  line-height: 1.16;
  margin-bottom: 30px;
}
.tagline {
  max-width: 495px;
  font-family: "Roboto", sans-serif;
  font-size: 1.375rem;
  line-height: 1.36;
  // font-size: 1.5625rem;
}
.image {
  position: absolute;
  max-width: 275px;
  left: 50%;
  transform: translateX(-50%);
  // left: -564px;
  bottom: 0;
}
.image-ellipse {
  position: absolute;
  max-width: 527px;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  bottom: -155px;
  // bottom: -300px;
}
.menu-button {
  width: 28px;
  height: 23px;
  object-fit: contain;
  position: absolute;
  right: 20px;
  top: 50px;
  @media screen and (min-width: 600px) {
    display: none;
  }
}
</style>
